import {postRequest} from "./helper"
export const categoryAddApi = (data) => postRequest('admin/add-category',data);
export const categoryListApi = (data) => postRequest('admin/list-category',data);
export const categoryUpdateApi = (data) => postRequest('admin/update-category',data);
export const categoryEditApi = (data) => postRequest('admin/list-category',data);
export const categoryDeleteApi = (data) => postRequest('admin/delete-category',data);
export const categoryStatusApi = (data) => postRequest('admin/change-category-status',data);
export const categoryOrderApi = (data) => postRequest('admin/change-order-status',data);





// WEBPACK FOOTER //
// ./src/api/Admin/Category.js